import React from "react";
import PropTypes from "prop-types";
import LeftComponent from "components/Authorization/LeftComponent";

function RegisterRequestConfirm({ ...props }) {
  return (
    <main className="site--width">
      <div className="container_content_signin">
        <LeftComponent />
        <div className="container_global_password">
          <h5 style={{ textAlign: "center" }}>
            Thank you for requesting an account on MedCafe.
          </h5>
          <p className="password_description">
            We carefully review all of our membership requests on MedCafe and
            will send you an email with more information within the next 5
            working days.
          </p>
        </div>
      </div>
    </main>
  );
}

RegisterRequestConfirm.defaultProps = {};

RegisterRequestConfirm.propTypes = {};

export default RegisterRequestConfirm;



// WEBPACK FOOTER //
// ./src/containers/RegisterRequestConfirm/index.jsx